import { SvgIcon, SvgIconProps } from '../../../icons/SvgIcon';

export const SmileyFaceIcon = (props: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.75 10C2.75 5.99594 5.99594 2.75 10 2.75C14.0041 2.75 17.25 5.99594 17.25 10C17.25 14.0041 14.0041 17.25 10 17.25C5.99594 17.25 2.75 14.0041 2.75 10ZM10 1.25C5.16751 1.25 1.25 5.16751 1.25 10C1.25 14.8325 5.16751 18.75 10 18.75C14.8325 18.75 18.75 14.8325 18.75 10C18.75 5.16751 14.8325 1.25 10 1.25ZM10 14.25C8.46345 14.25 7.1751 13.1831 6.83681 11.75H13.1632C12.8249 13.1831 11.5365 14.25 10 14.25ZM6.5 10.25C5.83816 10.25 5.18901 10.8077 5.28656 11.5916C5.57832 13.9361 7.57676 15.75 10 15.75C12.4232 15.75 14.4217 13.9361 14.7134 11.5916C14.811 10.8077 14.1618 10.25 13.5 10.25H6.5ZM9 7C9 7.82843 8.32843 8.5 7.5 8.5C6.67157 8.5 6 7.82843 6 7C6 6.17157 6.67157 5.5 7.5 5.5C8.32843 5.5 9 6.17157 9 7ZM12.5 8.5C13.3284 8.5 14 7.82843 14 7C14 6.17157 13.3284 5.5 12.5 5.5C11.6716 5.5 11 6.17157 11 7C11 7.82843 11.6716 8.5 12.5 8.5Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
